import KyMethod from "./KyMethod"
import { SchoolListQuery, SchoolType } from "@interfaces/school"

export default class SchoolRepositories extends KyMethod {
  protected async getRawSchoolList(
    type: SchoolType,
    { page = 1, limit = 12, search }: Partial<SchoolListQuery>
  ) {
    return this._getPaginationData(`/schools`, {
      type: type ? type.toLocaleLowerCase() : "school",
      page,
      limit,
      ...(search && { search }),
    })
  }
}
